module.exports = __webpack_public_path__ + "img/jt-h.07061124.jpg";